import { useEffect, useState } from "react";

const DEFAULT_MOBILE_QUERY = "(max-width: 623px)";

// Guards against environments where window.matchMedia is unavailable (e.g. Jest/jsdom, SSR).
const getMatchMedia = () =>
  typeof window !== "undefined" && typeof window.matchMedia === "function"
    ? window.matchMedia
    : undefined;

/**
 * Tracks whether the viewport currently matches a mobile-width media query.
 * Defaults to the app's standard ≤623px breakpoint (see App.tsx).
 */
export function useIsMobile(query = DEFAULT_MOBILE_QUERY) {
  const [isMobile, setIsMobile] = useState(() => {
    const matchMedia = getMatchMedia();
    return matchMedia ? matchMedia(query).matches : false;
  });

  useEffect(() => {
    const matchMedia = getMatchMedia();
    if (!matchMedia) {
      return;
    }

    const mediaQueryList = matchMedia(query);
    const handleChange = () => setIsMobile(mediaQueryList.matches);

    // Sync in case the query string changed or the initial value drifted.
    handleChange();

    mediaQueryList.addEventListener("change", handleChange);

    return () => {
      mediaQueryList.removeEventListener("change", handleChange);
    };
  }, [query]);

  return isMobile;
}

export default useIsMobile;
